import { firestore } from '@psl/functions/firebase/firebaseAccess';
import { CategorizedResourceType } from '@psl/models/ClientModels';

export const userCategorizedResourcesQuery = (uid: string, limit?: number) => {
  const query = firestore()
    .collection('categorizedResources')
    .where('resourceType', '==', CategorizedResourceType.User)
    .where('userId' as any, '==', uid);
  return limit != null ? query.limit(limit) : query;
};
